const Scale = {
  Title1: 'font-size: 1.25rem;line-height: 1.5;',
  Title2: 'font-size: 1rem;line-height: 1.2;',
  Display: 'font-size: 0.8rem;line-height: 1.2;',
  Display1: 'font-size: 0.8rem;line-height: 1.5;',
  Display3: 'font-size: 1.5rem; line-height: 34px;',
};

const Weight = {
  100: 'font-weight: 100;',

  200: 'font-weight: 200;',

  300: 'font-weight: 300;',

  400: 'font-weight: 400;',

  500: 'font-weight: 500;',

  600: 'font-weight: 600;',

  700: 'font-weight: 700;',

  800: 'font-weight: 800;',

  900: 'font-weight: 900;',
};

const Family = 'font-family: Roboto, Arial, sans-serif;';

export const Fonts = {
  Scale,
  Weight,
  Family,
};
